import { hasValue } from '../general-utils';

export const getPPUrl = (path?: string): string => {
  const ppApiDomain =
    process.env['NEXT_PUBLIC_PP_API_DOMAIN'] ||
    process.env['PP_API_DOMAIN'] ||
    '';

  if (!path) {
    if (!hasValue(ppApiDomain))
      console.error('NEXT_PUBLIC_PP_API_DOMAIN is not defined');

    return ppApiDomain;
  }

  return `${ppApiDomain}${path}`;
};
